<div #container
     [class.no-transition]="isMouseDownOnImage"
     [class]="photo.uId">
  <img [attr.data-src]="imageUrl"
       [attr.src]="imgSrc"
       [ngStyle]="imageStyle"
       [alt]="photo.mediaAlt"
       class="image"
  />
  <div (click)="onImageClick($event)"
       (mousedown)="mouseDown($event)"
       (mousemove)="mouseMove($event)"
       (mouseup)="mouseUp($event)"
       (touchend)="mouseUp($event)"
       (touchmove)="mouseMove($event)"
       (touchstart)="mouseDown($event)"
       [class.freeze-pointer-events]="isZooming"
       [ngStyle]="layerStyle"
       class="layer-over-image"
  ></div>
</div>
